module.exports = __webpack_public_path__ + "img/th-box4-text-dark.89b41116.png";